import { BaseDto } from './base.dto';

export class ReminderDto extends BaseDto {
  name: string;
  date: Date;
  note?: string;
  isPrivate: boolean;
  isActive: boolean;
  recipientName: string;
  inProgress?: boolean;
  entity?: string;
  entityId?: number;

  static instanceOf(dto: Partial<ReminderDto>): ReminderDto {
    const reminder = new ReminderDto();

    const date = new Date();
    date.setHours(10, 0, 0, 0);

    reminder.isPrivate = dto.isPrivate || false;
    reminder.name = dto.name;
    reminder.date = dto.date || date;
    reminder.note = dto.note;
    reminder.isActive = dto.isActive;
    reminder.recipientName = dto.recipientName || dto.createdBy;
    reminder.entity = dto.entity;
    reminder.entityId = dto.entityId;

    return reminder;
  }
}
